// test1283
(1283 && 0);
